/* September of Sausages — Custom Sausage Builder (Wolki Farm)
   Standalone, Liquid-free. Hosted on Shopify Files CDN; loaded by a tiny theme
   section. Finds every .sos-builder[data-sos-root], reads its JSON config, injects
   styles once, builds the 4-step UI, prices it, and adds a 10kg batch to cart with
   the full recipe as line-item properties. Catalogue + price->variant map below. */
(function () {
  'use strict';

  /* ---- Catalogue (edit here, then re-upload this file) ---- */
  var MEATS = [
    { v: 'beef', label: 'Beef', emoji: '🐄', game: false },
    { v: 'pork', label: 'Pork', emoji: '🐖', game: false },
    { v: 'lamb', label: 'Lamb', emoji: '🐑', game: false },
    { v: 'venison', label: 'Venison', emoji: '🦌', game: true },
    { v: 'goat', label: 'Goat', emoji: '🐐', game: true },
    { v: 'wildboar', label: 'Wild Boar', emoji: '🐗', game: true }
  ];
  /* Basic seasonings, grouped by category (included in base price, up to maxSeason). */
  var SEASONING_GROUPS = [
    { cat: 'Salt & Pepper', items: ['Salt', 'Smoked Salt', 'Cracked Black Pepper', 'White Pepper', 'Szechuan Pepper', 'Native Pepperberry', 'Chilli Flakes', 'Cayenne'] },
    { cat: 'Seeds & Warm Spices', items: ['Fennel Seed', 'Coriander Seed', 'Cumin', 'Mustard Seed', 'Caraway', 'Celery Seed', 'Nigella Seed', 'Fenugreek', 'Anise / Star Anise', 'Cardamom', 'Allspice', 'Clove', 'Cinnamon', 'Nutmeg', 'Mace', 'Juniper', 'Turmeric', 'Ginger'] },
    { cat: 'Herbs', items: ['Sage', 'Rosemary', 'Thyme', 'Marjoram', 'Oregano', 'Parsley', 'Basil', 'Tarragon', 'Dill', 'Chives', 'Bay Leaf', 'Savory'] },
    { cat: 'Aromatics & Umami', items: ['Garlic', 'Onion Powder', 'Black Garlic', 'Porcini Powder', 'Sumac', 'Lemon Zest', 'Orange Zest'] }
  ];
  var SEASONINGS = SEASONING_GROUPS.reduce(function (a, g) { return a.concat(g.items); }, []);
  /* Adventurous add-ins, grouped by category. Truffle is the luxe pick (✦). */
  var ADDIN_GROUPS = [
    { cat: 'Cheese', items: ['Vintage Cheddar', 'Mozzarella', 'Blue Cheese', 'Feta', 'Halloumi', 'Smoked Cheese', 'Parmesan', 'Brie', 'Pepper Jack'] },
    { cat: 'Sweet & Fruit', items: ['Wolki Farm Honey', 'Maple Syrup', 'Apple', 'Fig', 'Date', 'Cranberry', 'Apricot', 'Mango', 'Pineapple', 'Dark Chocolate', 'Golden Syrup'] },
    { cat: 'Savoury & Umami', items: ['Caramelised Onion', 'Roasted Garlic', 'Leek', 'Sun-dried Tomato', 'Kalamata Olives', 'Mushroom', 'Miso', { n: 'Truffle', luxe: true }, 'Vegemite', 'Seeded Mustard', 'Peanut Butter'] },
    { cat: 'Heat & Pickled', items: ['Jalapeño', 'Kimchi', 'Pickled Onion', 'Gherkin', 'Hot Honey', 'Chipotle'] },
    { cat: 'Booze & Wildcard', items: ['Stout', 'Bourbon', 'Bacon'] }
  ];
  ADDIN_GROUPS.forEach(function (g) { g.items = g.items.map(function (it) { return typeof it === 'string' ? { n: it } : it; }); });
  var ADDINS = ADDIN_GROUPS.reduce(function (a, g) { return a.concat(g.items); }, []);
  /* ordered thinnest -> thickest (left -> right) */
  var CASINGS = [
    { v: 'collagen', label: 'Thin', casing: 'Collagen (synthetic)', dim: '17mm', desc: 'Skinny, uniform snack-stick / thin breakfast snag. Great value.' },
    { v: 'sheep', label: 'Medium', casing: 'Sheep (natural)', dim: '22–26mm', desc: 'Chipolata / breakfast size. Tender, with the classic "snap".' },
    { v: 'hog', label: 'Thick', casing: 'Hog (natural)', dim: '32–38mm', desc: 'Traditional banger / bratwurst. Hearty and robust.' }
  ];
  /* band price -> Shopify variant id (Custom Sausage — 10kg Batch) */
  var PRODUCT_HANDLE = 'custom-sausage-10kg-batch';
  var VARIANT_MAP = null;
  function loadVariants(){ return fetch('/products/'+PRODUCT_HANDLE+'.js',{headers:{Accept:'application/json'}}).then(function(r){return r.json();}).then(function(p){var m={};(p.variants||[]).forEach(function(v){m[Math.round(v.price/100)]=v.id;});VARIANT_MAP=m;return m;}); }
  function getVariantId(band){ return VARIANT_MAP?Promise.resolve(VARIANT_MAP[band]):loadVariants().then(function(m){return m[band];}); }
  var BAND_MIN = 300, BAND_MAX = 400;

  var CSS =
    '.sos-builder{max-width:1120px;margin:0 auto;padding:32px 18px 96px;color:#3a2a1a}' +
    '.sos-builder *{box-sizing:border-box}' +
    '.sos-head{text-align:center;margin-bottom:28px}' +
    '.sos-kicker{letter-spacing:.18em;text-transform:uppercase;font-size:12px;font-weight:700;color:#8a5a2b;margin:0 0 8px}' +
    '.sos-title{font-size:clamp(28px,5vw,44px);line-height:1.05;margin:0 0 10px}' +
    '.sos-sub{font-size:clamp(15px,2.4vw,19px);opacity:.8;margin:0 auto;max-width:640px}' +
    '.sos-intro{margin:16px auto 0;max-width:700px;border:1.5px solid #e2d5c2;border-radius:14px;padding:16px 22px;background:#fffaf3}' +
    '.sos-intro p{margin:0}' +
    '.sos-promo{max-width:840px;margin:22px auto 34px;background:#153d15;border:1.5px solid #3f8f3a;border-radius:14px;padding:15px 20px;color:#fff;font-size:15px;line-height:1.5;text-align:center}' +
    '.sos-promo p{margin:0}' +
    '.sos-promo strong{color:#a9e39b}' +
    '.sos-grid{display:grid;grid-template-columns:1fr;gap:26px}' +
    '@media(min-width:900px){.sos-grid{grid-template-columns:1.35fr .95fr;align-items:start}.sos-summary{position:sticky;top:100px;align-self:start}}' +
    '.sos-step{background:#fff;border:1px solid #ece4d8;border-radius:16px;padding:20px 18px;margin-bottom:18px;box-shadow:0 2px 10px rgba(60,40,20,.04)}' +
    '.sos-step-h{display:flex;align-items:center;gap:10px;font-size:20px;margin:0 0 6px}' +
    '.sos-num{display:inline-flex;align-items:center;justify-content:center;width:28px;height:28px;border-radius:50%;background:#7a3b12;color:#fff;font-size:15px;font-weight:700;flex:none}' +
    '.sos-step-note{margin:0 0 14px;font-size:14px;opacity:.72}' +
    '.sos-blocks{display:grid;grid-template-columns:repeat(2,1fr);gap:12px}' +
    '@media(min-width:560px){.sos-blocks{grid-template-columns:repeat(4,1fr)}}' +
    '.sos-block{display:flex;flex-direction:column;gap:6px}' +
    '.sos-block label{font-size:12px;font-weight:700;opacity:.6}' +
    '.sos-block select{width:100%;padding:11px 10px;border:1.5px solid #000;border-radius:10px;background:#111;font-size:15px;font-weight:600;color:#fff;appearance:auto}' +
    '.sos-block select:focus{outline:none;border-color:#4caf50}' +
    '.sos-block select option{background:#fff;color:#111}' +
    '.sos-chips{display:flex;flex-wrap:wrap;gap:9px}' +
    '.sos-subhead{font-size:12px;font-weight:800;text-transform:uppercase;letter-spacing:.1em;color:#7a3b12;margin:16px 0 9px}' +
    '.sos-subhead:first-child{margin-top:0}' +
    '.sos-chip{border:1.5px solid #000;background:#111!important;color:#fff!important;border-radius:999px;padding:9px 14px;font-size:14px;font-weight:600;cursor:pointer;transition:.12s;line-height:1.1}' +
    '.sos-chip:hover{border-color:#4caf50}' +
    '.sos-builder .sos-chip[aria-pressed="true"],.sos-builder .sos-chip[aria-pressed="true"]:hover,.sos-builder .sos-chip[aria-pressed="true"]:focus,.sos-builder .sos-chip[aria-pressed="true"]:active{background:#3f8f3a!important;border-color:#3f8f3a!important;color:#fff!important}' +
    '.sos-builder .sos-chip[data-luxe][aria-pressed="true"]{background:#2f6f2c!important;border-color:#2f6f2c!important}' +
    '.sos-chip:disabled{opacity:.4;cursor:not-allowed}' +
    '.sos-plus{opacity:.6;font-weight:700;margin-left:5px}' +
    '.sos-casings{display:grid;grid-template-columns:1fr;gap:11px}' +
    '@media(min-width:520px){.sos-casings{grid-template-columns:repeat(3,1fr)}}' +
    '.sos-casing{border:1.5px solid #000;background:#111!important;color:#fff!important;border-radius:12px;padding:16px 13px;cursor:pointer;transition:.12s;text-align:center}' +
    '.sos-casing:hover{border-color:#4caf50}' +
    '.sos-builder .sos-casing[aria-pressed="true"],.sos-builder .sos-casing[aria-pressed="true"]:hover,.sos-builder .sos-casing[aria-pressed="true"]:focus,.sos-builder .sos-casing[aria-pressed="true"]:active{border-color:#6fdf5f!important;background:#3f8f3a!important;box-shadow:0 0 0 2px #6fdf5f inset}' +
    '.sos-casing .sos-dim{display:block;font-size:28px;font-weight:800;line-height:1;color:#fff;letter-spacing:.01em}' +
    '.sos-casing b{display:block;font-size:12px;font-weight:800;text-transform:uppercase;letter-spacing:.12em;color:#a9e39b;margin-top:6px}' +
    '.sos-casing[aria-pressed="true"] b{color:#eafbe6}' +
    '.sos-casing small{display:block;font-size:12.5px;opacity:.85;margin-top:6px;color:#fff}' +
    '.sos-card{background:#fff8ef;border:1px solid #e7d8c2;border-radius:16px;padding:20px}' +
    '.sos-card-h{margin:0 0 12px;font-size:18px}' +
    '.sos-recipe{margin:0;display:grid;grid-template-columns:auto 1fr;gap:6px 14px;font-size:14px}' +
    '.sos-recipe dt{font-weight:700;opacity:.6}' +
    '.sos-recipe dd{margin:0;text-align:right}' +
    '.sos-price-row{display:flex;justify-content:space-between;align-items:baseline;margin:16px 0 12px;padding-top:14px;border-top:1px dashed #d9c7ac}' +
    '.sos-price{font-size:30px;font-weight:800;color:#7a3b12}' +
    '.sos-lead,.sos-ship{font-size:12.5px;opacity:.72;margin:8px 0 0}' +
    '.sos-notes{margin-top:14px}' +
    '.sos-notes-l{display:block;font-size:12px;font-weight:800;text-transform:uppercase;letter-spacing:.05em;color:#7a3b12;margin-bottom:6px}' +
    '.sos-notes-t{width:100%;box-sizing:border-box;border:1.5px solid #d9ccbb!important;border-radius:10px;padding:10px;font-size:14px;font-family:inherit;resize:vertical;background:#fff!important;color:#3a2a1a!important}' +
    '.sos-notes-t:focus{outline:none;border-color:#7a3b12!important}' +
    '.sos-notes-d{font-size:11.5px;line-height:1.45;opacity:.72;margin:8px 0 0}' +
    '.sos-err{color:#b3261e;font-size:13px;font-weight:600;margin:10px 0 0}' +
    /* kill the Xclusive theme black ::before/::after overlay that hides button backgrounds */
    '.sos-builder .sos-chip::before,.sos-builder .sos-chip::after,.sos-builder .sos-casing::before,.sos-builder .sos-casing::after{display:none!important;content:none!important;background:none!important}' +
    /* .template-page overflow-x:hidden forces overflow-y:auto and breaks position:sticky; clip fixes it without a scroll container */
    '.template-page{overflow-x:clip!important;overflow-y:visible!important}' +
    '.sos-builder button.sos-btn{width:100%;border:none!important;border-radius:12px!important;background:#7a3b12!important;color:#fff!important;font-size:16px!important;font-weight:700!important;padding:15px 18px!important;cursor:pointer;margin-top:14px;letter-spacing:.01em;transition:.12s;text-transform:none!important}' +
    '.sos-builder button.sos-btn::before,.sos-builder button.sos-btn::after{display:none!important;content:none!important}' +
    '.sos-builder button.sos-btn:hover{background:#8f4718!important}' +
    '.sos-builder button.sos-btn:disabled{background:#c4b09a!important;cursor:not-allowed}' +
    '.sos-mobilebar{display:none}' +
    '@media(max-width:899px){' +
    '.sos-summary{position:static!important}' +
    '.sos-mobilebar{display:flex;position:sticky;bottom:0;z-index:20;align-items:center;gap:12px;background:#fff;border-top:1px solid #e7d8c2;padding:10px 14px;margin:18px -18px -96px;box-shadow:0 -4px 14px rgba(60,40,20,.08)}' +
    '.sos-mobilebar-price{display:flex;flex-direction:column;line-height:1.1}' +
    '.sos-mobilebar-price small{font-size:11px;opacity:.6}' +
    '.sos-mobilebar-price strong{font-size:20px;color:#7a3b12}' +
    '.sos-mobilebar .sos-btn{width:auto;margin:0;flex:1;padding:13px 18px!important}}';

  function injectCss() {
    if (document.getElementById('sos-styles')) return;
    var s = document.createElement('style');
    s.id = 'sos-styles';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  var money = function (n) { return '$' + Number(n).toFixed(2).replace(/\.00$/, ''); };
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function meatOf(v) { for (var i = 0; i < MEATS.length; i++) { if (MEATS[i].v === v) return MEATS[i]; } return MEATS[0]; }
  function casingOf(v) { for (var i = 0; i < CASINGS.length; i++) { if (CASINGS[i].v === v) return CASINGS[i]; } return CASINGS[1]; }
  /* Selected-state colours applied as INLINE !important so no theme CSS (even ID/:hover rules) can override. */
  function paintChip(c, on) {
    var g = on ? (c.dataset.luxe ? '#2f6f2c' : '#3f8f3a') : '#111';
    c.style.setProperty('background', g, 'important');
    c.style.setProperty('color', '#fff', 'important');
    c.style.setProperty('border-color', on ? g : '#000', 'important');
  }
  function paintCasing(c, on) {
    c.style.setProperty('background', on ? '#3f8f3a' : '#111', 'important');
    c.style.setProperty('color', '#fff', 'important');
    c.style.setProperty('border-color', on ? '#6fdf5f' : '#000', 'important');
    c.style.setProperty('box-shadow', on ? '0 0 0 2px #6fdf5f inset' : 'none', 'important');
  }

  function build(root) {
    var cfgNode = root.querySelector('[data-sos-config]');
    if (!cfgNode) return;
    var cfg = JSON.parse(cfgNode.textContent);
    /* Default copy lives here (editable via theme-editor settings, which override these). */
    cfg.kicker = cfg.kicker || 'September of Sausages';
    cfg.heading = cfg.heading || 'Build Your Own Sausage';
    cfg.subheading = cfg.subheading || 'Design a bespoke 10kg batch — your meat, your flavours, your casing. Made to order and dispatched in 7–10 days.';
    cfg.introHtml = cfg.introHtml || '<p>Ever had a cracking idea for a <strong>hero snag</strong>? A flavour you just <em>HAVE</em> to try — or a viral sausage you’ve seen online and can’t stop thinking about? This is your moment. Fire up our <strong>Custom Snag</strong> builder and design your own sausage from scratch — we build the price as you go.</p>';
    cfg.promoHtml = cfg.promoHtml || '<p>🏆 Here’s the fun part: we’ll cook up a few snags from every batch in-house (don’t worry — you’ll still receive your full 10kg!). The <strong>best snag</strong> gets offered to the public for a limited time — <strong>PLUS</strong> its creator wins a <strong>$500 Wolki Farm online gift voucher</strong>!</p>';
    cfg.lead = cfg.lead || 'Made to order — dispatched in 7–10 days.';
    cfg.shipping = cfg.shipping || 'Free local pickup - flat-rate $30 national shipping.';
    cfg.base = 300; cfg.gamePremium = 0;   /* pricing set here (2026-07-04) */
    cfg.addin = 2; cfg.luxe = 10;
    cfg.casing = { sheep: 0, hog: 0, collagen: 0 };
    cfg.maxSeason = 999; cfg.maxAddin = cfg.maxAddin || 40;
    var state = { blocks: ['beef', 'beef', 'beef', 'beef'], seasonings: [], addins: [], casing: 'hog' };

    /* ---- layout ---- */
    var inner = el('div', 'sos-inner');
    var head = el('div', 'sos-head',
      (cfg.kicker ? '<p class="sos-kicker">' + esc(cfg.kicker) + '</p>' : '') +
      '<h1 class="sos-title">' + esc(cfg.heading || 'Build Your Own Sausage') + '</h1>' +
      (cfg.subheading ? '<p class="sos-sub">' + esc(cfg.subheading) + '</p>' : '') +
      (cfg.introHtml ? '<div class="sos-intro">' + cfg.introHtml + '</div>' : ''));
    inner.appendChild(head);

    if (cfg.promoHtml) inner.appendChild(el('div', 'sos-promo', cfg.promoHtml));

    var grid = el('div', 'sos-grid');
    var steps = el('div', 'sos-steps');

    var blocksWrap = el('div', 'sos-blocks');
    steps.appendChild(stepBox('1', 'Choose your meat blend',
      'Four 2.5&nbsp;kg blocks make up your 10&nbsp;kg batch. Same meat in every block for a single-meat snag, or mix &amp; match &mdash; each block is 25%.', blocksWrap));

    var seasWrap = el('div', 'sos-seasonings');
    steps.appendChild(stepBox('2', 'Basic seasonings',
      'Tap to add as many as you like &mdash; all included in your batch price.', seasWrap));

    var addWrap = el('div', 'sos-addins');
    steps.appendChild(stepBox('3', 'Adventurous add-ins',
      'The fun stuff &mdash; stack as many as you like across the categories below. <b>&#10022;</b> marks our luxe pick.', addWrap));

    var casWrap = el('div', 'sos-casings');
    steps.appendChild(stepBox('4', 'Casing &amp; thickness',
      'Your casing sets the thickness and bite of the finished sausage.', casWrap));

    grid.appendChild(steps);

    var card = el('div', 'sos-card',
      '<h3 class="sos-card-h">Your recipe</h3>' +
      '<dl class="sos-recipe">' +
      '<dt>Meat blend</dt><dd data-out="blend">&mdash;</dd>' +
      '<dt>Seasonings</dt><dd data-out="season">None</dd>' +
      '<dt>Add-ins</dt><dd data-out="addin">None</dd>' +
      '<dt>Casing</dt><dd data-out="casing">&mdash;</dd>' +
      '<dt>Batch</dt><dd>10&nbsp;kg &middot; made to order</dd>' +
      '</dl>' +
      '<div class="sos-price-row"><span>Your batch</span><span class="sos-price" data-out="price">&mdash;</span></div>' +
      '<button type="button" class="sos-btn" data-add>Add my 10kg batch to cart</button>' +
      '<p class="sos-lead" data-out="lead"></p>' +
      (cfg.shipping ? '<p class="sos-ship">' + esc(cfg.shipping) + '</p>' : '') +
      '<div class="sos-notes"><label class="sos-notes-l">Special requests (optional)</label>' +
      '<textarea class="sos-notes-t" data-note rows="3" placeholder="e.g. go easy on the chilli, extra garlic, keep it 60/40..."></textarea>' +
      '<p class="sos-notes-d">' + esc('How do we work out the ratios of your ingredients? We run every recipe past Mrs W and Butcher Paul for their input on ratios, and also run each recipe through AI to glean extra insight. If you have any specific recommendations we must stick to, please add them in the box above.') + '</p></div>' +
      '<p class="sos-err" data-err hidden></p>');
    var aside = el('div', 'sos-summary'); aside.appendChild(card);
    grid.appendChild(aside);

    inner.appendChild(grid);

    var mbar = el('div', 'sos-mobilebar',
      '<div class="sos-mobilebar-price"><small>10kg batch</small><strong data-out="price-m">&mdash;</strong></div>' +
      '<button type="button" class="sos-btn" data-add>Add to cart</button>');

    root.appendChild(inner);
    root.appendChild(mbar);
    if (window.console) console.log('Sausage Builder build 9 loaded');

    /* ---- controls ---- */
    var meatOptions = MEATS.map(function (m) { return '<option value="' + m.v + '">' + m.emoji + ' ' + m.label + '</option>'; }).join('');
    for (var i = 0; i < 4; i++) {
      var blk = el('div', 'sos-block', '<label>Block ' + (i + 1) + ' · 2.5kg</label><select data-block="' + i + '">' + meatOptions + '</select>');
      blocksWrap.appendChild(blk);
    }
    blocksWrap.querySelectorAll('select').forEach(function (sel) {
      sel.value = state.blocks[+sel.dataset.block];
      sel.addEventListener('change', function () { state.blocks[+this.dataset.block] = this.value; render(); });
    });

    SEASONING_GROUPS.forEach(function (g) {
      seasWrap.appendChild(el('div', 'sos-subhead', g.cat));
      var chips = el('div', 'sos-chips');
      g.items.slice().sort(function (a, b) { return a.localeCompare(b); }).forEach(function (s) {
        var c = el('button', 'sos-chip'); c.type = 'button'; c.setAttribute('aria-pressed', 'false'); c.dataset.val = s; c.textContent = s;
        c.addEventListener('click', function () { toggle('seasonings', s, cfg.maxSeason); });
        chips.appendChild(c);
      });
      seasWrap.appendChild(chips);
    });
    ADDIN_GROUPS.forEach(function (g) {
      addWrap.appendChild(el('div', 'sos-subhead', g.cat));
      var chips = el('div', 'sos-chips');
      g.items.slice().sort(function (a, b) { return a.n.localeCompare(b.n); }).forEach(function (a) {
        var c = el('button', 'sos-chip'); c.type = 'button'; c.setAttribute('aria-pressed', 'false'); c.dataset.val = a.n; if (a.luxe) c.dataset.luxe = '1';
        c.innerHTML = esc(a.n) + (a.luxe ? ' <span class="sos-plus">✦</span>' : '');
        c.addEventListener('click', function () { toggle('addins', a.n, cfg.maxAddin); });
        chips.appendChild(c);
      });
      addWrap.appendChild(chips);
    });
    CASINGS.forEach(function (c) {
      var b = el('button', 'sos-casing'); b.type = 'button'; b.dataset.val = c.v;
      b.innerHTML = '<span class="sos-dim">' + c.dim + '</span><b>' + c.label + '</b><small>' + c.casing + ' — ' + c.desc + '</small>';
      b.addEventListener('click', function () { state.casing = this.dataset.val; render(); });
      casWrap.appendChild(b);
    });

    function toggle(key, val, max) {
      var arr = state[key], i = arr.indexOf(val);
      if (i > -1) arr.splice(i, 1); else { if (arr.length >= max) return; arr.push(val); }
      render();
    }

    /* ---- pricing ---- */
    function gameBlocks() { return state.blocks.filter(function (v) { return meatOf(v).game; }).length; }
    function addinCost() {
      return state.addins.reduce(function (sum, n) {
        var a = ADDINS.filter(function (x) { return x.n === n; })[0];
        return sum + (a && a.luxe ? cfg.luxe : cfg.addin);
      }, 0);
    }
    function raw() { return cfg.base + gameBlocks() * cfg.gamePremium + addinCost() + (cfg.casing[state.casing] || 0); }
    function band() { var p = Math.ceil(raw() / 2) * 2; if (p < BAND_MIN) p = BAND_MIN; if (p > BAND_MAX) p = BAND_MAX; return p; }

    function blendText() {
      var counts = {}; state.blocks.forEach(function (v) { counts[v] = (counts[v] || 0) + 1; });
      return MEATS.filter(function (m) { return counts[m.v]; }).map(function (m) {
        return (counts[m.v] * 25) + '% ' + m.label + ' (' + (counts[m.v] * 2.5) + 'kg)';
      }).join(' · ');
    }

    function set(name, val) { root.querySelectorAll('[data-out="' + name + '"]').forEach(function (e) { e.textContent = val; }); }

    function render() {
      seasWrap.querySelectorAll('.sos-chip').forEach(function (c) {
        var on = state.seasonings.indexOf(c.dataset.val) > -1;
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
        paintChip(c, on);
        c.disabled = !on && state.seasonings.length >= cfg.maxSeason;
      });
      addWrap.querySelectorAll('.sos-chip').forEach(function (c) {
        var on = state.addins.indexOf(c.dataset.val) > -1;
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
        paintChip(c, on);
        c.disabled = !on && state.addins.length >= cfg.maxAddin;
      });
      casWrap.querySelectorAll('.sos-casing').forEach(function (c) {
        var on = c.dataset.val === state.casing;
        c.setAttribute('aria-pressed', on ? 'true' : 'false');
        paintCasing(c, on);
      });
      var cas = casingOf(state.casing);
      set('blend', blendText());
      set('season', state.seasonings.length ? state.seasonings.join(', ') : 'None');
      set('addin', state.addins.length ? state.addins.join(', ') : 'None');
      set('casing', cas.label + ' — ' + cas.casing + ' (' + cas.dim + ')');
      var p = money(band());
      set('price', p); set('price-m', p);
      set('lead', cfg.lead || '');
    }

    /* ---- add to cart ---- */
    function props() {
      var cas = casingOf(state.casing);
      return {
        'Meat Blend': blendText(),
        'Seasonings': state.seasonings.length ? state.seasonings.join(', ') : 'None',
        'Adventurous Add-ins': state.addins.length ? state.addins.join(', ') : 'None',
        'Casing / Thickness': cas.label + ' — ' + cas.casing + ', ' + cas.dim,
        'Batch size': '10kg (minimum order)',
        'Lead time': 'Made to order — dispatches in 7–10 days',
        'Special requests': ((root.querySelector('[data-note]') || {}).value || '').trim() || 'None'
      };
    }
    root.querySelectorAll('[data-add]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var errEl = root.querySelector('[data-err]');
        errEl.hidden = true;
        var self = this, old = self.textContent; self.disabled = true; self.textContent = 'Adding…';
        getVariantId(band()).then(function (id) {
          if (!id) throw new Error('no-variant');
          return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: id, quantity: 1, properties: props() }] }) });
        }).then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
          .then(function () { window.location.href = '/cart'; })
          .catch(function () { self.disabled = false; self.textContent = old; errEl.hidden = false; errEl.textContent = 'Something went wrong adding to cart. Please try again, or email jake@wolkifarm.com.au.'; });
      });
    });

    render();
  }

  function stepBox(num, title, note, contentEl) {
    var box = el('div', 'sos-step', '<h2 class="sos-step-h"><span class="sos-num">' + num + '</span> ' + title + '</h2><p class="sos-step-note">' + note + '</p>');
    box.appendChild(contentEl);
    return box;
  }
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;'); }

  function init() {
    injectCss(); loadVariants();
    document.querySelectorAll('.sos-builder[data-sos-root]').forEach(function (root) {
      if (root.dataset.sosReady) return;
      root.dataset.sosReady = '1';
      build(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
